import { render, staticRenderFns } from "./editor_trace.vue?vue&type=template&id=37dca702"
import script from "./editor_trace.vue?vue&type=script&lang=js"
export * from "./editor_trace.vue?vue&type=script&lang=js"
import style0 from "./editor_trace.vue?vue&type=style&index=0&id=37dca702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports